'use client'
import Image from "next/image";
import React, { useState, useEffect } from "react";

const HeroImage = ({ images }) => {
  
  const [currentIndex, setCurrentIndex] = useState(0);
  
  useEffect(() => {
    if (images.length <= 1) return;
    
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3500);
    
    return () => clearInterval(interval);
  }, [images]);
  
  if (!images || images.length === 0) return null;
  
  return (
    <div className="relative w-full h-96  overflow-hidden">
      {images.map((image, index) => (
        <Image
          key={index}
          src={image.src}
          alt={image.alt || "Hero image"}
          width={1920}
          height={1080}
          priority
          className={`w-full h-full object-cover absolute inset-0 transition-opacity duration-1000 ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}
    </div>
  );
};

export default HeroImage;
